/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Course } from '../models';
/**
 * CourseApi - axios parameter creator
 * @export
 */
export const CourseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesGet: async (facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {string} [expirationDateUtc] 
         * @param {string} [confirmationNote] 
         * @param {number} [numberOfSlots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        holdUnusedFloatingBarterSlotsAsyncPost: async (courseId?: number, teeTime?: string, expirationDateUtc?: string, confirmationNote?: string, numberOfSlots?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/HoldUnusedFloatingBarterSlotsAsync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (teeTime !== undefined) {
                localVarQueryParameter['teeTime'] = (teeTime as any instanceof Date) ?
                    (teeTime as any).toISOString() :
                    teeTime;
            }

            if (expirationDateUtc !== undefined) {
                localVarQueryParameter['expirationDateUtc'] = (expirationDateUtc as any instanceof Date) ?
                    (expirationDateUtc as any).toISOString() :
                    expirationDateUtc;
            }

            if (confirmationNote !== undefined) {
                localVarQueryParameter['confirmationNote'] = confirmationNote;
            }

            if (numberOfSlots !== undefined) {
                localVarQueryParameter['numberOfSlots'] = numberOfSlots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseUnusedFloatingBarterSlotsAsyncPost: async (courseId?: number, teeTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ReleaseUnusedFloatingBarterSlotsAsync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (teeTime !== undefined) {
                localVarQueryParameter['teeTime'] = (teeTime as any instanceof Date) ?
                    (teeTime as any).toISOString() :
                    teeTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseApi - functional programming interface
 * @export
 */
export const CourseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coursesGet(facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Course>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coursesGet(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.coursesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {string} [expirationDateUtc] 
         * @param {string} [confirmationNote] 
         * @param {number} [numberOfSlots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async holdUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, expirationDateUtc?: string, confirmationNote?: string, numberOfSlots?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.holdUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, expirationDateUtc, confirmationNote, numberOfSlots, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.holdUnusedFloatingBarterSlotsAsyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.releaseUnusedFloatingBarterSlotsAsyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CourseApi - factory interface
 * @export
 */
export const CourseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesGet(facilityId?: number, options?: any): AxiosPromise<Array<Course>> {
            return localVarFp.coursesGet(facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {string} [expirationDateUtc] 
         * @param {string} [confirmationNote] 
         * @param {number} [numberOfSlots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        holdUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, expirationDateUtc?: string, confirmationNote?: string, numberOfSlots?: number, options?: any): AxiosPromise<void> {
            return localVarFp.holdUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, expirationDateUtc, confirmationNote, numberOfSlots, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {string} [teeTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, options?: any): AxiosPromise<void> {
            return localVarFp.releaseUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseApi - object-oriented interface
 * @export
 * @class CourseApi
 * @extends {BaseAPI}
 */
export class CourseApi extends BaseAPI {
    /**
     * 
     * @param {number} [facilityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseApi
     */
    public coursesGet(facilityId?: number, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).coursesGet(facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [courseId] 
     * @param {string} [teeTime] 
     * @param {string} [expirationDateUtc] 
     * @param {string} [confirmationNote] 
     * @param {number} [numberOfSlots] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseApi
     */
    public holdUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, expirationDateUtc?: string, confirmationNote?: string, numberOfSlots?: number, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).holdUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, expirationDateUtc, confirmationNote, numberOfSlots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [courseId] 
     * @param {string} [teeTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseApi
     */
    public releaseUnusedFloatingBarterSlotsAsyncPost(courseId?: number, teeTime?: string, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).releaseUnusedFloatingBarterSlotsAsyncPost(courseId, teeTime, options).then((request) => request(this.axios, this.basePath));
    }
}

